//引入接口文档
import req from '@/utils/req.js'
//权限菜单详情
export function addColumn(params) {
    return req.post("/admin/column",params);
}
//获取栏目分页
export function columnList(params) {
    return req.post("/admin/column/page",params);
}
//栏目详细查询
export function columnDetailed(params) {
    return req.get(`/dsicm-data-base/feign/column/${params.id}`);
}
//修改栏目
export function editColumn(params) {
    return req.put("/admin/column",params);
}
//启用
export function enableColumn(params) {
    return req.put(`/admin/column/${params.id}/enable`);
}
//停用
export function disableColumn(params) {
    return req.put(`/admin/column/${params.id}/disable`);
}
//删除栏目
export function deleteColumn(params) {
    return req.delete(`/admin/column/${params.id}`);
}

